import {handleActions} from 'redux-actions';

import {
  GET_VOLUME_PERFORMANCE_USER_LIST,
  RESET_REPORT,
  SET_FILTERS,
  SET_IS_END_REACHED,
  SET_IS_FETCHING_NEXT_PAGE,
  SET_IS_LIST_LOADING,
  SET_RESULTS_COUNT,
  SET_SORT,
  VolumePerformanceFilters,
  VolumePerformanceReportState,
  VolumePerformanceUser,
} from '/redux/action/volumePerformanceReport.action';
import {withPayload} from '/util/reducer.util';

import {INITIAL_VOLUME_PERFORMANCE_STATE} from '../../component/screen/report/VolumePerformanceReport/constants/volumePerformanceReport.constants';

export default handleActions<VolumePerformanceReportState, any>(
  {
    [SET_IS_LIST_LOADING]: withPayload(
      (state: VolumePerformanceReportState, isListLoading: boolean) => ({
        ...state,
        isListLoading,
      }),
    ),
    [SET_IS_FETCHING_NEXT_PAGE]: withPayload(
      (state: VolumePerformanceReportState, isFetchingNextPage: boolean) => ({
        ...state,
        isFetchingNextPage,
      }),
    ),
    [SET_IS_END_REACHED]: withPayload(
      (state: VolumePerformanceReportState, isEndReached: boolean) => ({
        ...state,
        isEndReached,
      }),
    ),
    [SET_RESULTS_COUNT]: withPayload(
      (state: VolumePerformanceReportState, resultsCount: number) => ({
        ...state,
        resultsCount,
      }),
    ),
    [SET_FILTERS]: withPayload(
      (
        state: VolumePerformanceReportState,
        filters: VolumePerformanceFilters,
      ) => ({
        ...state,
        filters,
      }),
    ),
    [SET_SORT]: withPayload(
      (
        state: VolumePerformanceReportState,
        sort: {sortBy: 'orderDate' | 'amount'; sortOrder: 'ASC' | 'DESC'},
      ) => ({
        ...state,
        sort,
      }),
    ),
    [GET_VOLUME_PERFORMANCE_USER_LIST]: withPayload(
      (
        state: VolumePerformanceReportState,
        {data, append}: {data: VolumePerformanceUser[]; append: boolean},
      ) => ({
        ...state,
        data: append ? [...state.data, ...data] : data,
      }),
    ),
    [RESET_REPORT]: () => INITIAL_VOLUME_PERFORMANCE_STATE,
  },
  INITIAL_VOLUME_PERFORMANCE_STATE,
);
